<div fxFlex>
  <div [ngSwitch]="toolbarType">
    <ng-template [ngSwitchCase]="1">
      <ng-container *ngTemplateOutlet="listTemplate"></ng-container>
    </ng-template>
    <ng-template [ngSwitchCase]="2">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </ng-template>

    <ng-template [ngSwitchCase]="3">
      <ng-container *ngTemplateOutlet="listTemplate"></ng-container>
    </ng-template>
  </div>
</div>

<ng-template #listTemplate>
  <mat-toolbar class="grey-toolbar p-8">
    <mat-toolbar-row fxLayout="row">
      <div class="m-0">
        <span class="heading toolbar-text">{{ heading }}</span>
      </div>
    </mat-toolbar-row>

    <mat-toolbar-row fxLayout="row wrap" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxFlex>
        <div fxLayout="column" fxFlex>
          <!-- Breadcrumb -->
          <div class="breadcrumb-container" *ngIf="breadcrumb && breadcrumb.length > 1">
            <span
              class="breadcrumb-item"
              [class.breadcrumb-clickable]="isClickable(item)"
              *ngFor="let item of getBreadcrumbItems(); let i = index"
              (click)="isClickable(item) && navigateToBreadcrumb(item)"
            >
              {{ getBreadcrumbItem(item, i).label }}
              <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
            </span>
          </div>
          <!-- Title -->
          <h1 class="toolbar-text" [ngStyle]="{'margin-bottom.px': 10}" [ngStyle.gt-xs]="{'margin-bottom.px': 0}">
            {{ title }}
          </h1>
        </div>
        <popover
          fxLayour="row wrap"
          style="display: inline-block; margin-left: 10px"
          [title]="popOverTitle"
          [msg]="popOverText"
          class="popover"
          *ngIf="popOverTitle && popOverText"
        ></popover>
        <span class="heading toolbar-text" style="margin-top: 6px; margin-left: 32px" *ngIf="toolbarType === 3">
          {{ heading }}
        </span>
      </div>

      <ng-content select="ian-header-toolbar-action"></ng-content>
    </mat-toolbar-row>
  </mat-toolbar>
</ng-template>

<ng-template #formTemplate>
  <mat-toolbar class="grey-toolbar" [class.ian-header-toolbar--sticky]="sticky" fxLayout="column">
    <mat-toolbar-row fxLayout="row" class="isList">
      <div class="m-0">
        <span class="heading toolbar-text">{{ heading }}</span>
      </div>
    </mat-toolbar-row>
    <!-- PRICING-S06: fila sticky con título + acciones (XPath mat-toolbar-row[2]) -->
    <mat-toolbar-row
      fxLayout="row wrap"
      fxFlex="50"
      fxLayoutAlign="space-between center"
      class="ian-header-toolbar-actions-row"
      [class.ian-header-toolbar-actions-row--sticky]="sticky"
    >
      <div fxLayout="row" fxFlex fxLayoutAlign="start center">
        <button
          *ngIf="returnToUrl?.length > 0"
          mat-icon-button
          [routerLink]="returnToUrl"
          [queryParams]="returnToUrlinkParams"
          class="toolbar-text"
          [attr.data-test-id]="'back-previus-page'"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div fxLayout="column">
          <!-- Breadcrumb -->
          <div class="breadcrumb-container" *ngIf="breadcrumb && breadcrumb.length > 1">
            <span
              class="breadcrumb-item"
              [class.breadcrumb-clickable]="isClickable(item)"
              *ngFor="let item of getBreadcrumbItems(); let i = index"
              (click)="isClickable(item) && navigateToBreadcrumb(item)"
            >
              {{ getBreadcrumbItem(item, i).label }}
              <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
            </span>
          </div>
          <!-- Title -->
          <h1
            [matTooltip]="title"
            class="toolbar-text"
            [ngStyle]="{'margin-bottom.px': 10}"
            [ngStyle.gt-xs]="{'margin-bottom.px': 0}"
          >
            <!-- {{ (title?.length>26)? (title | slice:0:24)+'..':(title) }} -->
            <!-- se utiliza con font size dinamico al ancho de la pantalla -->
            {{ (title?.length>62)? (title | slice:0:60)+'..':(title) }}
          </h1>

          <span class="heading toolbar-text subtitle">{{ subTitle }}</span>
          <ng-content select="ian-header-subtitle"></ng-content>
        </div>
      </div>

      <ng-content select="ian-header-toolbar-form-action"></ng-content>
    </mat-toolbar-row>
  </mat-toolbar>
</ng-template>
